import parse from 'csv-parse';

// IXL Analytics usage export (CSV) detector for the HB 1416 tracker.
//
// CONSERVATIVE BY DESIGN: this must NEVER false-positive on a STAAR/EOC/roster/TELPAS/CCMR
// upload, so it keys ONLY on header tokens that are unique to an IXL export and appear in no
// other TEA/CoPilot file:
//   - "SmartScore"     (IXL's proprietary mastery metric; appears nowhere else), OR
//   - "Skills practiced" (IXL Time Spent / Quickview column), OR
//   - a student-name column AND an IXL time column ("Time spent" / a "Practice" time column).
// A verified sweep of the sibling validators confirmed none of these tokens collide with any
// other detected file type. The accountability year is read from the filename's 4-digit token
// (the usage export carries no accountability-year column); if absent we treat it as NOT this
// type rather than guessing, matching isAcceleratedTesters' year-required posture.
const norm = (s) =>
  String(s == null ? '' : s)
    .trim()
    .toLowerCase();

const hasHeader = (headers, predicate) => headers.some((h) => predicate(norm(h)));

const isIxlUsage = (file) =>
  new Promise((resolve) => {
    if (file.type != 'application/vnd.ms-excel' && file.type != 'text/csv') {
      resolve({ isValid: false });
      return;
    }
    const yearMatch = (file.name || '').match(/(\d{4})/);
    if (!yearMatch) {
      resolve({ isValid: false });
      return;
    }
    const year = yearMatch[1];
    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      // IXL exports ship with CRLF endings and can have a trailing blank line; be lenient
      // about the body since only the header row is needed for detection.
      parse(text, { skip_empty_lines: true, relax_column_count: true, trim: true }, (err, output) => {
        if (err || !output || !output[0]) {
          resolve({ isValid: false });
          return;
        }
        const headers = output[0];
        const hasSmartScore = hasHeader(headers, (h) => h.includes('smartscore') || h.includes('smart score'));
        const hasSkillsPracticed = hasHeader(headers, (h) => h.includes('skills practiced'));
        const hasName = hasHeader(
          headers,
          (h) => h === 'student name' || h === 'student' || h === 'name' || h === 'full name'
        );
        const hasTimeCol = hasHeader(
          headers,
          (h) => h === 'time spent' || h === 'total time' || h.includes('practice')
        );
        const isValid = hasSmartScore || hasSkillsPracticed || (hasName && hasTimeCol);
        resolve(isValid ? { isValid: true, year } : { isValid: false });
      });
    };
    reader.readAsText(file);
  });

export default isIxlUsage;
